/**
 * @generated SignedSource<<b7477d6edacd1858138151754e4d5055>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AnswerListItem_Video$data = {
  readonly id: string;
  readonly url: string;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItemStatus_Video">;
  readonly " $fragmentType": "AnswerListItem_Video";
};
export type AnswerListItem_Video$key = {
  readonly " $data"?: AnswerListItem_Video$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItem_Video">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerListItem_Video",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AnswerListItemStatus_Video"
    }
  ],
  "type": "Video",
  "abstractKey": null
};

(node as any).hash = "b5e623420fe636cd5b228997d4b835a7";

export default node;
